import React, { useEffect, useMemo, useRef, useState } from "react";
import { useWatch } from "antd/lib/form/Form";
import {
  Col,
  Form,
  message,
  Row,
  Upload,
  Button,
  Divider,
  Radio,
  Card,
  Flex,
  Alert,
  Table,
  ConfigProvider,
  Tag,
  DatePicker as AntdDatePicker,
  Modal,
  Select,
} from "antd";
import { color } from "../../../../resource";
import ImgCrop from "../../../../components/ImgCrop/ImgCrop";
import styled from "styled-components";
import Text from "../../../../components/Text/Text";
import { ImageWithDeleteButton, UploadIcon } from "../../../../components/Image/Image";
import Input from "../../../../components/Input/Input";
import DatePicker, { TimePicker } from "../../../../components/DatePicker/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import ReactQuill, { Quill } from "react-quill";
import {
  CalendarOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import image from "../../../../resource/image";
import icon from "../../../../resource/icon";
import { getBase64 } from "../../../../utility/uploadHelper";
import { RcFile } from "antd/lib/upload";
import Buttons from "../../../../components/Button/Button";
import { useRecoilState } from "recoil";
import { campaignState } from "../../../../store/createCampaign";
import { checkCampaignCode } from "../../../../datasource/CampaignDatasource";
import { ModalPreviewFile, readFileAsBase64 } from "../../../NewCODiscount/CODiscountComponent";

const UploadHorizontal = styled(Upload)`
  .ant-upload,
  .ant-upload-list-picture-card-container,
  .ant-upload-picture-card-wrapper,
  .ant-upload-list-picture-card .ant-upload-list-item {
    height: 130px;
    width: 220px;
  }
`;
const UploadArea = styled.div`
  background: ${color.background1};
  border: 1px dashed;
  border-radius: 6px;

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
`;

const imgCropProps = {
  modalTitle: "ปรับขนาดรูปภาพ",
  modalOk: "ยืนยัน",
  modalCancel: "ยกเลิก",
};

const QuillContainer = styled.div`
  .ql-toolbar.ql-snow {
    border-radius: 4px 4px 0 0 !important;
  }

  .ql-container.ql-snow {
    border-radius: 0 0 4px 4px !important;
  }

  .ql-editor {
    min-height: 120px;
    max-height: 80vh;
    overflow-y: auto;
  }
`;

const MemoArea = styled.div`
  width: 100%;
  background: ${color.background1};
  border: 1px solid ${color.background2};
  border-radius: 8px;

  display: flex;
  align-items: center;
  padding: 16px;
`;

const MemoAreaItem = styled.div`
  padding: 0px 8px;
  display: flex;
  align-items: center;
`;

const ImageFormContainer = styled.div`
  .ant-form-item-explain-error {
    margin-top: 16px;
  }
`;

export const StepOne = ({ form, form2 }: { form: any; form2: any }) => {
  const userProfile = JSON.parse(localStorage.getItem("profile")!);
  const { company } = userProfile;
  const quillRef = useRef<any>(null);
  const previewSize = 290;

  const { pathname } = window.location;
  const pathSplit = pathname.split("/") as Array<string>;
  const id = pathSplit[3];
  const isEditing = !!id;

  const [showVideoModal, setVideoModal] = useState(false);
  const [vidIndex, setVidIndex] = useState();
  const [modalSameDate, setModalSameDate] = useState(false);

  const campaignName = useWatch("campaignName", form);
  const watchStartDate = useWatch("startDate", form) || "";
  const watchEndDate = useWatch("endDate", form) || "";
  const watchDeadline = useWatch("campaignDeadlines", form);
  const watchCondition = useWatch("campaignCondition", form);
  const watchCampaignProgramType = useWatch("campaignProgramType", form);
  const watchDocumentUrl = useWatch("documentUrl", form);
  const watchImageUrl = useWatch("horizontalImageUrl", form);

  const [openPdf, setOpenPdf] = useState(false);
  const [previewFile, setPreviewFile] = useState<string | undefined>(undefined);

  useEffect(() => {
    form.setFieldsValue({ isRebate: true });
  }, []);

  const videoHandler = useMemo(() => {
    return () => {
      const quill = quillRef?.current?.getEditor();
      const range = quill.getSelection();
      setVidIndex(range.index);
      setVideoModal(true);
    };
  }, []);

  const modules = {
    toolbar: {
      container: [
        ["bold", "italic", "link", "image"],
        [{ size: ["small", false, "large", "huge"] }],
        [{ align: "" }, { align: "center" }, { align: "right" }],
        [{ list: "ordered" }, { list: "bullet" }],
      ],
    },
    imageResize: {
      parchment: Quill.import("parchment"),
      modules: ["Resize", "DisplaySize"],
    },
  };

  const deadlineDocument = () => {
    const dataForm = form.getFieldsValue(true);
    const totalMonths =
      dayjs(dataForm.endDate)
        .startOf("month")
        .diff(dayjs(dataForm.startDate).startOf("month"), "month") + 1;

    const monthLoop = Array.from(
      {
        length: totalMonths,
      },
      (_, i) => {
        const currentMonth = dayjs(dataForm.startDate).add(i, "month");
        const month = currentMonth.month() + 1;
        const year = currentMonth.year();
        const nextMonth = currentMonth.add(1, "month");
        const findSetDate = dataForm.campaignDeadlines?.find((m) => m.month === month);

        return {
          month,
          year,
          deadlineMonth: currentMonth.format("YYYY-MM"),
          subDealerSubmitDate: findSetDate?.subDealerSubmitDate || dayjs(nextMonth).date(5),
          dealerCheckDate: findSetDate?.dealerCheckDate || dayjs(nextMonth).date(15),
          companyApproveDate: findSetDate?.companyApproveDate || dayjs(nextMonth).date(25),
        };
      },
    );
    form.setFieldValue("campaignDeadlines", monthLoop);

    const columns = [
      {
        title: "ใบขนเดือน",
        dataIndex: "month",
        key: "month",
        render: (text, record) => {
          return (
            <Tag style={{ backgroundColor: "#E6F0FE", border: "none" }}>
              <Text
                fontWeight={700}
              >{`${dayjs(`${record.year}-${record.month}`).locale("th").format("MMM BBBB")}`}</Text>
            </Tag>
          );
        },
      },
      {
        title: "วันสุดท้าย Sub-Dealer ส่งใบขน",
        dataIndex: "subDealerSubmitDate",
        key: "subDealerSubmitDate",
        render: (text, record, index) => {
          return (
            <Form.Item name={["campaignDeadlines", index, "subDealerSubmitDate"]}>
              <AntdDatePicker
                allowClear={false}
                showToday={false}
                style={{ width: "100%", height: "40px" }}
                format='DD MMM BBBB'
                suffixIcon={<CalendarOutlined />}
                disabledDate={(current) => {
                  const endDate = form.getFieldValue("endDate");
                  const dataDeadlines = form.getFieldValue("campaignDeadlines");
                  const dealerCheckDate = dataDeadlines?.[index]?.dealerCheckDate;
                  const currentMonthStart = dayjs(
                    dataDeadlines?.[index]?.subDealerSubmitDate,
                  ).startOf("month");

                  return (
                    (current && current < currentMonthStart) ||
                    (dealerCheckDate && current > dayjs(dealerCheckDate).startOf("day"))
                    //|| (endDate && current > dayjs(endDate).startOf("day"))
                  );
                }}
              />
            </Form.Item>
          );
        },
      },
      {
        title: "วันสุดท้าย Dealer ตรวจสอบ",
        dataIndex: "dealerCheckDate",
        key: "dealerCheckDate",
        render: (text, record, index) => {
          return (
            <Form.Item name={["campaignDeadlines", index, "dealerCheckDate"]}>
              <AntdDatePicker
                allowClear={false}
                showToday={false}
                style={{ width: "100%", height: "40px" }}
                format='DD MMM BBBB'
                suffixIcon={<CalendarOutlined />}
                disabledDate={(current) => {
                  const dataDeadlines = form.getFieldValue("campaignDeadlines");
                  const companyApproveDate = dataDeadlines?.[index]?.companyApproveDate;
                  const subDealerSubmitDate = dayjs(dataDeadlines?.[index]?.subDealerSubmitDate);
                  return (
                    (current && current < subDealerSubmitDate) ||
                    (companyApproveDate && current > dayjs(companyApproveDate).startOf("day"))
                  );
                }}
              />
            </Form.Item>
          );
        },
      },
      {
        title: "วันสุดท้ายบริษัทอนุมัติ",
        dataIndex: "companyApproveDate",
        key: "companyApproveDate",
        render: (text, record, index) => {
          return (
            <Form.Item name={["campaignDeadlines", index, "companyApproveDate"]}>
              <AntdDatePicker
                allowClear={false}
                showToday={false}
                style={{ width: "100%", height: "40px" }}
                format='DD MMM BBBB'
                suffixIcon={<CalendarOutlined />}
                disabledDate={(current) => {
                  const dataDeadlines = form.getFieldValue("campaignDeadlines");
                  const subDealerSubmitDate = dayjs(dataDeadlines?.[index]?.subDealerSubmitDate);
                  const companyApproveDate = dayjs(
                    dataDeadlines?.[index]?.companyApproveDate,
                  ).endOf("month");
                  return (
                    (current && current < subDealerSubmitDate.startOf("day")) ||
                    (current && current > companyApproveDate)
                  );
                }}
              />
            </Form.Item>
          );
        },
      },
    ];

    return (
      <>
        <div style={{ paddingBottom: "10px" }}>
          <Text level={5} fontWeight={600}>
            กำหนดวันส่งและตรวจสอบเอกสารใบขน
          </Text>
        </div>
        <Alert
          message='เอกสารใบขนของแต่ละเดือน นับตามวันที่ขน, หลังวันสุดท้ายที่ Sub-Dealer ส่งเอกสาร ระบบปิดรับและปิดแก้ไขเอกสารของเดือนนั้นใน LINE OA, เอกสารที่ Dealer ไม่ตรวจสอบ หรือบริษัทไม่อนุมัติภายในวันที่กำหนดจะมีสถานะ เกินกำหนด'
          type='info'
          showIcon
          icon={<ExclamationCircleOutlined style={{ fontSize: "16px", paddingBottom: "18px" }} />}
          style={{
            paddingBottom: "10px",
            backgroundColor: "#F3F6F9",
            borderRadius: "6px",
            borderColor: "#F3F6F9",
          }}
        />
        <br />
        <div style={{ paddingBottom: "10px" }}>
          <Text color='Text3'>
            ระยะเวลาแคมเปญ :{" "}
            <Text fontWeight={700}>
              {dayjs(dataForm.startDate).locale("th").format("DD MMM BBBB")} -{" "}
              {dayjs(dataForm.endDate).locale("th").format("DD MMM BBBB")}
            </Text>
          </Text>
        </div>
        <Card
          bodyStyle={{ padding: "16px" }}
          style={{ borderRadius: "20px", borderColor: "#E5EAEE" }}
        >
          <Row justify='space-between' align='middle'>
            <Col>
              <Text fontWeight={700}>วันสุดท้ายของการส่งและตรวจสอบใบขนรายเดือน</Text>
            </Col>
            <Col>
              <Buttons
                typeButton='primary-light'
                title='ตั้งค่า Deadline วันเดียวกัน'
                style={{ height: "32px" }}
                onClick={() => setModalSameDate(true)}
              />
            </Col>
          </Row>
          <br />
          <ConfigProvider
            theme={{
              components: {
                Table: {
                  headerBg: "#F3F6F9",
                  fontFamily: "IBM Plex Sans Thai",
                  fontSize: 15,
                },
              },
            }}
          >
            <Table
              columns={columns}
              dataSource={form?.getFieldValue("campaignDeadlines") || []}
              pagination={false}
              size='small'
            />
          </ConfigProvider>
        </Card>
      </>
    );
  };

  return (
    <>
      <Row justify='space-between' gutter={8}>
        <Col span={17}>
          <Text level={5} fontWeight={700}>
            รายละเอียดแคมเปญ
          </Text>
          <br />
          <br />
          <Form
            form={form}
            layout='vertical'
            initialValues={{
              campaignProgramType: company === "ICPL" ? "ONLY_DEALER" : undefined,
              imageAction: "NO_ACTION",
              documentAction: "NO_ACTION",
            }}
          >
            <Row justify='start' gutter={48}>
              <Col span={7}>
                <ImageFormContainer>
                  <Form.Item
                    name='horizontalImageUrl'
                    rules={[
                      {
                        validator(rule, value, callback) {
                          if (value) {
                            callback();
                            return Promise.resolve();
                          }
                          return Promise.reject(new Error("*โปรดอัปโหลดรูปภาพ"));
                        },
                      },
                    ]}
                  >
                    <ImgCrop aspect={16 / 9} {...imgCropProps}>
                      <UploadHorizontal
                        listType='picture-card'
                        maxCount={1}
                        beforeUpload={(file) => {
                          const isJpgOrPng =
                            file.type === "image/jpeg" || file.type === "image/png";
                          if (!isJpgOrPng) {
                            message.error("You can only upload JPG/PNG file!");
                            return true;
                          }
                          getBase64(file as RcFile, (url) => {
                            form.setFieldsValue({
                              horizontalImage: file,
                              imageAction: "UPLOAD",
                              horizontalImageUrl: url,
                              imagePath: undefined,
                            });
                          });
                        }}
                        customRequest={() => {
                          console.log("customRequest");
                        }}
                        onChange={({ file }: any) => {
                          return "success";
                        }}
                        onRemove={() => {
                          form.setFieldsValue({
                            horizontalImage: undefined,
                            horizontalImageUrl: undefined,
                            imageAction: "DELETE",
                            imagePath: undefined,
                          });
                        }}
                        showUploadList={false}
                        disabled={
                          !!form.getFieldValue("horizontalImage") ||
                          !!form.getFieldValue("horizontalImageUrl")
                        }
                      >
                        {!form.getFieldValue("horizontalImage") && !watchImageUrl ? (
                          <>
                            <UploadArea
                              style={{
                                width: "220px",
                                height: "130px",
                                //borderColor: imgPromotion ? color.error : color.Text3,
                              }}
                            >
                              {UploadIcon}
                            </UploadArea>
                          </>
                        ) : (
                          <ImageWithDeleteButton
                            width='220px'
                            height='130px'
                            src={watchImageUrl}
                            handleDelete={() => {
                              form.setFieldsValue({
                                horizontalImageUrl: undefined,
                                horizontalImage: undefined,
                                imageAction: "DELETE",
                                imagePath: undefined,
                              });
                            }}
                          />
                        )}
                      </UploadHorizontal>
                    </ImgCrop>
                  </Form.Item>
                </ImageFormContainer>
              </Col>
              <Col span={17}>
                <Text level={6} color='Text3'>
                  รูปภาพประกอบแคมเปญ
                  <br />
                  รูปแบบไฟล์ภาพ
                  <br />
                  JPG / PNG
                  <br />
                  ขนาดภาพ
                  <br />
                  1200 x 675 px (16:9)
                </Text>
              </Col>
            </Row>
            <br />
            <Row gutter={8} justify='space-between'>
              <Col span={12}>
                <Form.Item
                  name='campaignCode'
                  label='รหัสแคมเปญ'
                  rules={[
                    {
                      required: true,
                      message: "โปรดระบุรหัสแคมเปญ",
                    },
                    {
                      validator: async (rule, code) => {
                        if (isEditing) return;
                        const success = code ? await checkCampaignCode(code) : true;
                        if (!success) {
                          throw new Error("รหัสโปรโมชันนี้ถูกใช้แล้ว");
                        }
                      },
                    },
                  ]}
                >
                  <Input
                    placeholder='ระบุรหัสแคมเปญ'
                    autoComplete='off'
                    disabled={isEditing}
                    style={{ color: color.BK }}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name='campaignName'
                  label='ชื่อแคมเปญ'
                  rules={[
                    {
                      required: true,
                      message: "โปรดระบุชื่อแคมเปญ",
                    },
                  ]}
                >
                  <Input
                    placeholder='ระบุชื่อแคมเปญ'
                    autoComplete='off'
                    style={{ color: color.BK }}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row align='middle' gutter={16}>
              <Col span={12}>
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item
                      name='startDate'
                      label='วันที่เริ่มแคมเปญ'
                      rules={[
                        {
                          required: true,
                          message: "โปรดเลือกวันที่เริ่มโปรโมชัน",
                        },
                      ]}
                    >
                      <DatePicker
                        style={{ width: "100%" }}
                        disabled={isEditing}
                        enablePast
                        disabledDate={(current: Dayjs) => {
                          const endDate = form.getFieldValue("endDate");
                          if (!endDate) return false;
                          return current && current.isAfter(dayjs(endDate));
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name='startTime'
                      label='เวลาเริ่มต้นแคมเปญ'
                      initialValue={dayjs("00:00", "HH:mm")}
                    >
                      <TimePicker allowClear={false} />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col span={12}>
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item
                      name='endDate'
                      label='วันที่สิ้นสุดแคมเปญ'
                      rules={[
                        {
                          required: true,
                          message: "โปรดเลือกวันที่สิ้นสุดโปรโมชัน",
                        },
                      ]}
                    >
                      <DatePicker
                        style={{ width: "100%" }}
                        disabledDate={(current: Dayjs) => {
                          const startDate = form.getFieldValue("startDate");
                          return current && current.isBefore(dayjs(startDate));
                        }}
                        enablePast
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name='endTime'
                      label='เวลาสิ้นสุดแคมเปญ'
                      initialValue={dayjs("23:59", "HH:mm")}
                    >
                      <TimePicker
                        allowClear={false}
                        disabledTime={(now) => {
                          const startDate = form.getFieldValue("startDate") as Dayjs;
                          const endDate = form.getFieldValue("endDate") as Dayjs;
                          const startTime = form.getFieldValue("startTime") as Dayjs;
                          const isSameDay =
                            startDate && endDate && startDate?.isSame(endDate, "year");
                          if (!isSameDay) return {};

                          const hour = startTime.hour();
                          const minute = startTime.minute();
                          const hours: number[] = [];
                          const minutes: number[] = [];
                          for (let i = 0; i < hour; i++) {
                            hours.push(i);
                          }
                          for (let i = 0; i <= minute; i++) {
                            minutes.push(i);
                          }
                          return {
                            disabledHours: () => hours,
                            disabledMinutes: (selectedHour: number) =>
                              selectedHour === hour ? minutes : [],
                          };
                        }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
            <div style={{ paddingBottom: "10px" }}>
              <Text level={5} fontWeight={600}>
                รูปแบบการให้แต้มร้านค้า <Text color='error'>*</Text>
              </Text>
            </div>
            <Form.Item
              name='campaignProgramType'
              rules={[
                {
                  required: true,
                  message: "โปรดเลือกรูปแบบการให้แต้มร้านค้า",
                },
              ]}
            >
              <Radio.Group
                className='mode-radio-group'
                onChange={(e) => {
                  form2.setFieldsValue({
                    campaignPrograms:
                      form2.getFieldValue("campaignPrograms").map((pg: any) => ({
                        ...pg,
                        campaignProgramDealers: [],
                        searchDealer: [],
                      })) || [],
                  });
                }}
              >
                <Radio value='ONLY_SUB_DEALER' disabled={company === "ICPL"}>
                  <Flex vertical>
                    <Text fontWeight={600} level={6}>
                      ให้ Sub-Dealer เท่านั้น
                    </Text>
                  </Flex>
                </Radio>
                <Radio value='ONLY_DEALER'>
                  <Flex vertical>
                    <Text fontWeight={600} level={6}>
                      ให้ Dealer เท่านั้น
                    </Text>
                  </Flex>
                </Radio>
              </Radio.Group>
            </Form.Item>
            {company !== "ICPL" && (
              <>
                <Form.Item name='campaignDeadlines' noStyle>
                  {watchStartDate &&
                    watchEndDate &&
                    watchCampaignProgramType === "ONLY_SUB_DEALER" && (
                      <>
                        {deadlineDocument()}
                        <br />
                        <Text level={5} fontWeight={600}>
                          อายุแต้มแคมเปญ <Text color='error'>*</Text>
                        </Text>
                        <br />
                        <Text color='Text3' level={6}>
                          สามารถเลือกวันหมดอายุแต้มแคมเปญได้ตั้งแต่{" "}
                          <Text fontWeight={600} color='Text3' level={6}>
                            วันสุดท้ายของเดือนที่บริษัทอนุมัติ
                          </Text>{" "}
                          {dayjs(
                            form?.getFieldValue("campaignDeadlines")[watchDeadline?.length - 1]
                              ?.companyApproveDate,
                          )
                            .locale("th")
                            .format("(DD MMM BBBB)")}
                        </Text>
                        <Form.Item
                          name='pointExpireDate'
                          rules={[
                            {
                              required: true,
                              message: "เลือกวันที่แต้มหมดอายุ",
                            },
                          ]}
                        >
                          <AntdDatePicker
                            format='DD/MM/BBBB'
                            showToday={false}
                            style={{ width: "100%", height: "40px" }}
                            placeholder='เลือกวันที่แต้มหมดอายุ'
                            disabledDate={(current) => {
                              const lastDeadline =
                                form?.getFieldValue("campaignDeadlines")?.[
                                  watchDeadline?.length - 1
                                ]?.companyApproveDate;

                              return (
                                current &&
                                (current < dayjs().startOf("day") ||
                                  current <= dayjs(lastDeadline).add(-1, "day").endOf("day"))
                              );
                            }}
                          />
                        </Form.Item>
                      </>
                    )}
                </Form.Item>
                <br />
              </>
            )}
            <Form.Item
              name='campaignCondition'
              label='กติกาและเงื่อนไขแคมเปญ'
              rules={[{ required: true, message: "กรุณากรอกกติกาและเงื่อนไข" }]}
            >
              <QuillContainer>
                <ReactQuill
                  value={watchCondition}
                  ref={quillRef}
                  modules={modules}
                  placeholder='ระบุกติกาและเงื่อนไข'
                  onChange={(c) => {
                    const isEmpty = !c.replace(/<[^>]*>/g, "").trim();
                    if (isEmpty) {
                      form.setFieldsValue({ campaignCondition: undefined });
                    } else {
                      form.setFieldsValue({ campaignCondition: c });
                    }
                  }}
                />
              </QuillContainer>
            </Form.Item>
            <Divider />
            <Text level={5} fontWeight={700}>
              ไฟล์เอกสารอ้างอิง
            </Text>
            <Row>
              <Col span={12}>
                <MemoArea>
                  <MemoAreaItem style={{ width: 124 }}>
                    <Form.Item
                      noStyle
                      name='memoFile'
                      //initialValue={[fileDoc]}
                    >
                      <Upload
                        beforeUpload={(file) => {
                          form.setFieldsValue({
                            documentAction: "UPLOAD",
                            documentPath: undefined,
                          });
                          const isPDF = file.type === "application/pdf";
                          if (!isPDF) {
                            message.error(`อัปโหลดเฉพาะไฟล์ pdf เท่านั้น`);
                            return false;
                          }
                          return isPDF || Upload.LIST_IGNORE;
                        }}
                        customRequest={({ file, onSuccess }) => {
                          if (onSuccess) {
                            onSuccess(file);
                          }
                        }}
                        onChange={async (info) => {
                          let newFileList: any = [...info.fileList].slice(-1);
                          newFileList = newFileList.map((file) => {
                            const localFile = file.originFileObj as File | undefined;
                            if (file.response?.url) {
                              file.url = file.response.url;
                            } else if (localFile) {
                              file.url = URL.createObjectURL(localFile);
                            }
                            return file;
                          });
                          form.setFieldsValue({
                            documentAction: "UPLOAD",
                            memoFile: newFileList[0].originFileObj,
                            documentUrl: newFileList[0].originFileObj.name,
                            documentPath: undefined,
                            documentBase64: await readFileAsBase64(newFileList[0].originFileObj),
                          });
                          return "success";
                        }}
                        onRemove={() => {
                          form.setFieldsValue({
                            documentAction: "DELETE",
                            memoFile: undefined,
                            documentUrl: undefined,
                            documentPath: undefined,
                          });
                        }}
                        maxCount={1}
                        showUploadList={false}
                        accept='application/pdf'
                        disabled={form.getFieldValue("memoFile")}
                      >
                        <Buttons
                          typeButton={form.getFieldValue("memoFile") ? "disabled" : "primary"}
                          title={
                            <>
                              <UploadOutlined /> เลือกไฟล์
                            </>
                          }
                        />
                      </Upload>
                    </Form.Item>
                  </MemoAreaItem>
                  <MemoAreaItem style={{ width: "calc(100% - 156px)" }}>
                    <img
                      src={icon.icon_pdf}
                      alt='PDF Icon'
                      style={{ width: "22px", height: "26px" }}
                    />
                    &nbsp;
                    <Form.Item name='documentUrl' noStyle>
                      <Text
                        onClick={() => {
                          if (
                            form.getFieldValue("documentUrl") ||
                            form.getFieldValue("documentBase64")
                          ) {
                            setPreviewFile(
                              form.getFieldValue("documentBase64") ||
                                form.getFieldValue("documentUrl"),
                            );
                            setOpenPdf(true);
                          }
                        }}
                        level={6}
                        color='Text3'
                        style={{
                          cursor:
                            form.getFieldValue("memoFile") ||
                            form.getFieldValue("documentUrl") ||
                            form.getFieldValue("documentBase64")
                              ? "pointer"
                              : "default",
                        }}
                      >
                        {form.getFieldValue("documentUrl")
                          ? (form.getFieldValue("documentUrl") as any)?.substring(0, 20) + "..."
                          : "โปรดเลือกไฟล์ .PDF"}
                      </Text>
                    </Form.Item>
                  </MemoAreaItem>
                  <MemoAreaItem
                    style={{
                      width: 32,
                      visibility:
                        (form.getFieldValue("memoFile") as any)?.originFileObj ||
                        form.getFieldValue("documentUrl")
                          ? "visible"
                          : "hidden",
                    }}
                  >
                    <DeleteOutlined
                      style={{ color: color.error, cursor: "pointer" }}
                      onClick={() => {
                        form.setFieldsValue({
                          documentAction: "DELETE",
                          memoFile: undefined,
                          documentUrl: undefined,
                        });
                      }}
                    />
                  </MemoAreaItem>
                </MemoArea>
              </Col>
            </Row>
          </Form>
        </Col>
        <Col>
          <div
            style={{
              backgroundColor: "#DFE3EC",
              overflow: "hidden",
              padding: "16px",
              borderRadius: "10px",
            }}
          >
            <Text level={5} fontWeight={700}>
              ตัวอย่างหน้า Application
            </Text>
            <Col>
              {form.getFieldValue("horizontalImageUrl") && (
                <div
                  style={{
                    position: "absolute",
                    margin: `${previewSize * 0.244}px 0px 0px`,
                    width: previewSize,
                    height: previewSize * (675 / 1200),
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundImage: `url(${form.getFieldValue("horizontalImageUrl")})`,
                    backgroundColor: "#FFFFFF40",
                  }}
                />
              )}
              <div
                style={{
                  position: "absolute",
                  marginTop: previewSize * 0.244 + previewSize * (675 / 1200) + 64,
                  width: previewSize,
                  padding: "2px 8px",
                }}
              >
                <Text
                  level={6}
                  fontWeight={600}
                  style={{
                    marginLeft: 20,
                    background: "white",
                    width: 180,
                    height: 24,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    display: "block",
                  }}
                >
                  &nbsp;{campaignName || `ชื่อแคมเปญ`}
                </Text>
              </div>
              <div
                style={{
                  position: "absolute",
                  marginTop: previewSize * 0.244 + previewSize * (675 / 1200) + 93,
                  width: previewSize,
                  padding: "2px 8px",
                  background: "#FAFAFA",
                }}
              >
                <Text fontWeight={600} level={6}>
                  ระยะเวลา : {watchStartDate && `${dayjs(watchStartDate).format("DD/MM/YYYY")} - `}
                  {watchEndDate && dayjs(watchEndDate).format("DD/MM/YYYY")}
                </Text>
              </div>
              <div
                style={{
                  position: "absolute",
                  marginTop: previewSize * 0.244 + previewSize * (675 / 1200) + 124,
                  width: previewSize,
                  padding: "2px 8px",
                }}
              >
                <Text color='Text1' fontWeight={600} level={6}>
                  {/* กติกาและเงื่อนไข */}
                </Text>
                <br />
                <div
                  className='view ql-editor'
                  style={{
                    display: "block",
                    wordBreak: "break-word",
                    wordWrap: "break-word",
                    overflowX: "hidden",
                    overflowY: "auto",
                    height: 244,
                    width: 260,
                    position: "absolute",
                    objectFit: "contain",
                  }}
                  dangerouslySetInnerHTML={{ __html: watchCondition || "" }}
                />
              </div>
              <div
                style={{
                  width: previewSize,
                  height: previewSize * 2.18,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: `${previewSize}px ${previewSize * 2.18}px`,
                  backgroundImage: `url(${image.campaignDetail})`,
                }}
              />
            </Col>
          </div>
        </Col>
      </Row>
      {modalSameDate && (
        <ModalSameDate
          modalSameDate={modalSameDate}
          setModalSameDate={setModalSameDate}
          onSubmit={(data) => {
            const dataCampaignDeadlines = form.getFieldsValue(true).campaignDeadlines;
            const newLoop = dataCampaignDeadlines.map((item: any) => {
              return {
                ...item,
                subDealerSubmitDate: dayjs(item.subDealerSubmitDate).date(data.sameDateSubDealer),
                dealerCheckDate: dayjs(item.dealerCheckDate).date(data.sameDateDealer),
                companyApproveDate: dayjs(item.companyApproveDate).date(data.sameDateCompany),
              };
            });
            form.setFieldsValue({ campaignDeadlines: newLoop });
            setModalSameDate(false);
          }}
        />
      )}
      {openPdf && (
        <ModalPreviewFile openPdf={openPdf} setOpenPdf={setOpenPdf} fileRef={previewFile} />
      )}
    </>
  );
};

const ModalSameDate = ({ modalSameDate, setModalSameDate, onSubmit }: any) => {
  const [formSameDate] = Form.useForm();
  const watchSameDateSubDealer = Form.useWatch("sameDateSubDealer", formSameDate);
  const watchSameDateDealer = Form.useWatch("sameDateDealer", formSameDate);
  const watchSameDateCompany = Form.useWatch("sameDateCompany", formSameDate);

  const dateOptions = useMemo(() => {
    const dateOptions = Array.from({ length: 31 }, (_, i) => ({
      value: i + 1,
      label: `วันที่ ${i + 1} ของเดือนถัดไป`,
      key: i + 1,
    }));
    return dateOptions;
  }, []);

  useMemo(() => {
    formSameDate.setFieldsValue({
      sameDateSubDealer: 5,
      sameDateDealer: 15,
      sameDateCompany: 25,
    });
  }, []);

  return (
    <Modal
      centered
      open={modalSameDate}
      width={800}
      onCancel={() => setModalSameDate(false)}
      onOk={() => onSubmit(formSameDate.getFieldsValue())}
      cancelButtonProps={{ style: { display: "none" } }}
      okText='บันทึก'
      maskClosable={false}
    >
      <Text level={3} fontWeight={600}>
        ตั้งค่าวัน Deadline เดียวกัน
      </Text>
      <Divider size='small' />
      <Form form={formSameDate} layout='vertical'>
        <Row justify='space-between' gutter={16}>
          <Col span={8}>
            <Form.Item label='วันสุดท้าย Sub-Dealer ส่งใบขน' name='sameDateSubDealer' required>
              <Select
                options={
                  dateOptions.map((option) => ({
                    ...option,
                    disabled: option.value > watchSameDateDealer,
                  })) || []
                }
                style={{ width: "100%", height: "40px" }}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label='วันสุดท้าย Dealer ตรวจสอบ' name='sameDateDealer' required>
              <Select
                options={
                  dateOptions.map((option) => ({
                    ...option,
                    disabled:
                      option.value > watchSameDateCompany || option.value < watchSameDateSubDealer,
                  })) || []
                }
                style={{ width: "100%", height: "40px" }}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label='วันสุดท้ายบริษัทอนุมัติ' name='sameDateCompany' required>
              <Select
                options={
                  dateOptions.map((option) => ({
                    ...option,
                    disabled: option.value < watchSameDateDealer,
                  })) || []
                }
                style={{ width: "100%", height: "40px" }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Divider />
      </Form>
    </Modal>
  );
};
